export const formatQueryParams = (
  payload: Record<string, any>
): URLSearchParams => {
  // 1. keeping only not null params
  const paramsEntries = Object.entries(payload).filter(([, value]) =>
    Boolean(value)
  );

  // 2. serializing not null params
  const serializedParams = new URLSearchParams();

  paramsEntries.forEach(([paramKey, paramValue]) => {
    serializedParams.append(paramKey, paramValue);
  });
  return serializedParams;
};

// to replace values like "{tenantId}" / "${internalDepotId}" etc. in url string
export const getUrlWithParams = (
  url: string,
  params: Record<string, string> = {}
): string => {
  let formattedUrl = url;

  Object.entries(params).forEach(([key, value]) => {
    formattedUrl = formattedUrl.replace(`{${key}}`, value);
  });

  return formattedUrl;
};
